import { FunctionComponent } from 'react';

import { Card as RadixCard, CardProps } from '@radix-ui/themes';

export const Card: FunctionComponent<CardProps> = (props: CardProps) => {
  return <RadixCard {...props} />;
};
